import { Decarbonisation as DecarbonisationReport } from "@idwal/idwal-react-components";
import { useQuery } from "react-query";
import DataRequest from "../../queries/DataRequest";
import { showRequestErrorToast } from "../../services/ErrorService";
import { Loading } from "../loading/Loading";
import { useTranslation } from "react-i18next";

export const Decarbonisation = () => {
    const pathname = window.location.pathname;
    const pathContent = pathname.split("/");
    const inspectionId = pathContent[2];

    const { t } = useTranslation("locale");

    if (!inspectionId) {
        showRequestErrorToast("summary (id)");
    }

    const { error, data, isLoading } = useQuery(["summary"], () =>
        DataRequest(inspectionId, "summary")
    );
    

    if (isLoading || data == undefined) return <Loading />;

    if (error) {
        showRequestErrorToast("Summary");
        return <div data-cy="summary-error"></div>;
    }

    const { ciiData, eexiData } = data;

    if (!ciiData && !eexiData) {
        return (
            <div
                className="flex justify-content-center align-items-center h-3rem"
                style={{ backgroundColor: "#FCFCFC" }}
                data-cy="no-decarbonisation"
            >
                {t("decarbonisation.no_decarbonisation")}
            </div>
        );
    }

    return <DecarbonisationReport ciiData={ciiData} eexiData={eexiData} paragraph={data?.decarbonisation} data-cy="decarbonisation-report" />;
};
